<glxy-badge [color]="color" [size]="'small'">{{ text }}</glxy-badge>
